/**
 * Hash that opens the Hair Analyzer. `initRevieve` from @notino/analyzer-tools
 * ties the whole Revieve lifecycle to it: the CDN script is loaded and the tool
 * initialized only once the hash matches, and it unmounts when the hash goes
 * away. Must stay in sync with the hair-analyzer-fragment's OPEN_HASH.
 */
export const HAIR_ANALYZER_OPEN_HASH = '#hairanalyzer';
